import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Invoice, QueryInvoiceArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryInvoiceArgs;
type TData = Invoice;

const MOCK: TVariables = { id: '' };

export const useInvoice = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query invoice($id: ID!) {
      invoice(id: $id) {
        amount
        chamberOfCommerce
        createdAt
        issuedAt
        currency
        dueDate
        fromAddress
        id
        legacy
        netAmount
        overdue
        paid
        paymentMethod
        customerNumber
        poCode
        taxAmount
        taxId
        toAddress
        invoiceItems {
          amount
          createdAt
          currency
          netAmount
          orderCode
          taxAmount
          taxCode
          taxRate
          title
          subItems {
            amount
            netAmount
            sourceLanguageCode
            targetLanguageCode
            taxAmount
            version
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['invoice', ...buildQueryKey(variables)],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
